//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';
import { useCallback } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import ModalAUpdate from '../Modal/Update/ModalAUpdate';
import ModalADelete from '../Modal/Delete/ModalADelete';

import { IconButton, Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { GlobalVariables } from '../../globalVar';
import ModalA from '../Modal/Create/ModalA';
import { useTour } from '@reactour/tour';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import useAssetsTour from '../../tours/assetsTour';
import { useTableLocale } from '../../hooks/useTableLocale';
import { useUserPermissions } from '../../hooks/userPermissions';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const AssetsTableAxios = () => {
  const permissions = useUserPermissions('AssetsTable');
  const canCreate = permissions.includes('Create Asset');
  const canUpdate = permissions.includes('Update Asset');
  const canDelete = permissions.includes('Delete Asset');
  // Config de hooks
  const [assetData, setAssetData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const {
    assetsString,
    assetNameString,
    assetSerialNumberStr,
    assetClientString,
    assetSiteString,
    assetLocationString,
    assetStatusString,
    noAssetsString,
    detailString,
    editString,
    deleteString,
    addString,
    viewTutorialString,
    createdAtString,
    createdByString,
    updatedAtString,
    updatedByString,
    notesString,
  } = useTranslationHook();

  const [modalAShow, setModalAShow] = useState(false);
  const [modalADeleteShow, setModalADeleteShow] = useState(false);

  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const assetsTour = useAssetsTour(setModalAShow);

  const locale = useTableLocale();

  useEffect(() => {
    // Check if assetsTour has not been viewed
    const hasSeenTour = localStorage.getItem('assetsTourViewed');

    if (canCreate && !hasSeenTour) {
      setIsOpen(true);
      setSteps(assetsTour);
      setCurrentStep(0);
      // assetsTour viewed
      localStorage.setItem('assetsTourViewed', 'true');
    }
  }, [assetsTour, canCreate, setCurrentStep, setIsOpen, setSteps]);

  const restartTour = () => {
    setIsOpen(true);
    setSteps(assetsTour);
    setCurrentStep(0);
    localStorage.setItem('assetsTourViewed', 'false');
  };

  useEffect(() => {
    const updateAssetData = () => {
      setAssetData((prevData) => {
        return prevData.map((asset) => ({
          ...asset,
          is_active: t(`${asset.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateAssetData);

    return () => {
      i18next.off('languageChanged', updateAssetData);
    };
  }, [t]);

  const endpoint = `${GlobalVariables.getURL()}listAssets?assetTypeId=1`;

  const getData = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const assetsResponse = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      const assetData = assetsResponse.map((asset) => {
        return {
          ...asset,
          is_active: t(`${asset.is_active}`),
        };
      });
      setAssetData(assetData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }, [endpoint, t]);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const [modalAUpdateShow, setModalAUpdateShow] = useState(false);

  function manageAssetDelete(assetInfo) {
    var assetId = assetInfo.id;
    localStorage.setItem('assetIdToDelete', assetId);

    var assetName = assetInfo.asset_name;
    var assetEquipName = assetInfo.equip_name;
    var assetClientSite = assetInfo.site_name;
    var assetUpdatedDate = assetInfo.updated_at;

    localStorage.setItem('assetNameToDelete', assetName);
    localStorage.setItem('assetEquipNameToDelete', assetEquipName);
    localStorage.setItem('assetClientSiteToDelete', assetClientSite);
    localStorage.setItem('assetUpdatedDateToDelete', assetUpdatedDate);
  }

  function manageAssetUpdate(assetInfo) {
    return new Promise((resolve, reject) => {
      var assetId = assetInfo.id;
      localStorage.setItem('assetIdForUpdate', assetId);

      customAxios
        .get(`${GlobalVariables.getURL()}autofillAsset/${assetId}`, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then((response) => {
          var assetData = response.data;
          localStorage.setItem(
            'assetDetailsForUpdate',
            JSON.stringify(assetData),
          );
          localStorage.setItem(
            'assetNameForUPlaceholder',
            assetData.asset_name,
          );
          localStorage.setItem(
            'assetDescriptionForUPlaceholder',
            assetData.description,
          );
          localStorage.setItem('assetAliasForUPlaceholder', assetData.alias);
          localStorage.setItem(
            'assetLocationForUPlaceholder',
            assetData.location,
          );
          localStorage.setItem(
            'assetSerialNForUPlaceholder',
            assetData.serial_number,
          );
          localStorage.setItem(
            'assetClientIdForUPlaceholder',
            assetData.client_id,
          );
          localStorage.setItem('assetSiteIdForUPlaceholder', assetData.site_id);
          localStorage.setItem(
            'assetModelIdForUPlaceholder',
            assetData.model_id,
          );
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      headerClassName: 'assets-datagrid-actions-tour',
      width: 220,
      renderCell: (params) => {
        return (
          <div className="cellAction assets-datagrid-actions-tour">
            {canUpdate && <Tooltip title={editString} arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={async () => {
                  try {
                    await manageAssetUpdate(params.row);
                    setModalAUpdateShow(true);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <ModeEditOutlineOutlinedIcon
                  className="detail-icons"
                  id="update-icon"
                />
              </button>
            </Tooltip>}
            {canDelete && <Tooltip title={deleteString} arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => {
                  setModalADeleteShow(true);
                  manageAssetDelete(params.row);
                }}
              >
                <DeleteIcon className="detail-icons" id="delete-icon" />
              </button>
            </Tooltip>}
          </div>
        );
      },
    },
  ];

  // Columnas
  const assetColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 100,
    },
    {
      field: 'asset_name',
      headerName: assetNameString,
      width: 130,
    },
    {
      field: 'equip_name',
      headerName: 'Tipo de equipo',
      width: 180,
    },
    {
      field: 'serial_number',
      headerName: assetSerialNumberStr,
      width: 180,
    },
    {
      field: 'num_activo',
      headerName: 'Núm. Activo',
      width: 150,
    },
    {
      field: 'model_name',
      headerName: 'Modelo',
      width: 180,
      renderCell: (params) => {
        const { model_name, model_brand_name } = params.row;
        if (!model_name) return '-';
        return model_brand_name
          ? `${model_name} (${model_brand_name})`
          : model_name;
      },
    },
    {
      field: 'business_name',
      headerName: assetClientString,
      width: 180,
    },
    {
      field: 'site_name',
      headerName: assetSiteString,
      width: 180,
    },
    {
      field: 'location',
      headerName: assetLocationString,
      width: 180,
    },
    {
      field: 'is_active',
      headerName: assetStatusString,
      width: 150,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className="statusActive">{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="statusInactive">{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'created_at',
      headerName: createdAtString,
      width: 150,
    },
    {
      field: 'created_by',
      headerName: createdByString,
      width: 150,
    },
    {
      field: 'updated_at',
      headerName: updatedAtString,
      width: 150,
    },
    {
      field: 'updated_by',
      headerName: updatedByString,
      width: 150,
    },
    {
      field: 'description',
      headerName: notesString,
      width: 200,
      renderCell: (params) =>
        params.row.description == null || params.row.description === 'null'
          ? ''
          : params.row.description,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  return (
    <>
      <div className="datatable-btns-container">
        <div className="dt-btn-main-container">
          <span className="dabiWebText">{assetsString} </span>
          {canCreate && <button
            className="add-button create-asset-tour"
            onClick={() => setModalAShow(true)}
          >
            {addString} <FontAwesomeIcon icon={faAdd} />
          </button>}
        </div>
        {canCreate && <Tooltip title={viewTutorialString}>
          <IconButton
            className="tour-button"
            size="medium"
            onClick={() => restartTour()}
          >
            <FontAwesomeIcon icon={faCircleInfo} />
          </IconButton>
        </Tooltip>}
      </div>

      <ModalA
        show={modalAShow}
        onHide={() => setModalAShow(false)}
        getAssets={getData}
        className="create-asset-form-tour"
      />

      <ModalADelete
        show={modalADeleteShow}
        onHide={() => setModalADeleteShow(false)}
        getAssets={getData}
      />

      <ModalAUpdate
        show={modalAUpdateShow}
        onHide={() => setModalAUpdateShow(false)}
        getAssets={getData}
      />

      <DataGridPro
        pagination
        loading={isLoading}
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
          pinnedColumns: { right: ['action'] },
        }}
        rows={assetData}
        columns={assetColumns.concat(canUpdate || canDelete ? actionColumn : [])}
        pageSize={5}
        disableSelectionOnClick
        rowsPerPageOptions={[5]}
        checkboxSelection={canDelete}
        slots={{
          noRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {noAssetsString}
            </Stack>
          ),
          toolbar: GridToolbar,
        }}
        className="assets-datagrid-tour"
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
      />
    </>
  );
};
